{
  "version": 1,
  "asset_id": "1094676a-449a-427d-b333-0fc70c81438e",
  "project_id": "b33bfd67-f8c1-4c76-9b0d-ef29c0f4772f",
  "url": "/__l5e/assets-v1/1094676a-449a-427d-b333-0fc70c81438e/sophia-return-of-wisdom.mp4",
  "original_filename": "sophia-return-of-wisdom.mp4",
  "size": 1104809211,
  "content_type": "video/mp4",
  "created_at": "2026-09-27T12:37:08Z"
}
